module.exports = __webpack_public_path__ + "static/media/Trekking.0c71da42.png";